module.exports = __webpack_public_path__ + "static/media/blankDayView.52fe625f.svg";